module.exports = __webpack_public_path__ + "static/media/linkedin.06f5dbae.svg";